var NewStoreID
var googleapisToken;
// Utility functions should come first
function formatDateToReadable(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const suffix = getDaySuffix(day);
  return `${day}${suffix} ${month}`;
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) return "th";
  switch (day % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}
 newhandleLocationSearchSelection = (place_id, key) => {
    
    const placesService = new google.maps.places.PlacesService(
        document.createElement("div")
    );
    placesService.getDetails(
        {
            placeId: place_id,
            fields: [
                "formatted_address",
                "name",
                "geometry",
                "place_id",
                "types",
                "address_components",
                "vicinity",
                "plus_code"
            ],
            sessionToken:googleapisToken,
        },
        (place, status) => {
            if (status === google?.maps?.places?.PlacesServiceStatus?.OK && place) {
                $(".service-not-applicable").html('')
                $(".location-suggestions").empty();
                googleapisToken = "";
                $(".location-suggestions-profile").empty();
                localStorage.removeItem("LOCATION");
                localStorage.removeItem("PickupLocation");
                localStorage.removeItem("LOCATION_PROFILE");
                localStorage.removeItem("GOOGLE_LOCATION");
                localStorage.setItem("GOOGLE_LOCATION", JSON.stringify(place));
                localStorage.removeItem("GOOGLE_LOCATION_PROFILE");
                localStorage.setItem(
                    "GOOGLE_LOCATION_PROFILE",
                    JSON.stringify(place)
                );
                localStorage.removeItem("SELECTEDADDRESSINDEXPAYMENT");
                const latitude = place?.geometry?.location.lat();
                const longitude = place?.geometry?.location.lng();
                 // const postalComponent = place.address_components.find(component =>
                 //    component.types.includes("postal_code")
                 //  );
                  // if (postalComponent) {
                  //   var postalCode = postalComponent.long_name;
                  //   console.log("Postal Code:", postalCode);
                  //   // localStorage.setItem("POSTAL_CODE", postalCode);
                  //   // $(".postal-code-label").html(postalCode);
                  // } else {
                  //   var postalCode = "";
                  //   console.log("Postal code not found in address_components.");
                  // }
              console.log("hello", longitude);
                if (latitude && longitude) {
  console.log("hello");

  const locationData = localStorage.getItem('GOOGLE_LOCATION');
  let locationObj = {};
  try {
    locationObj = JSON.parse(locationData) || {};
  } catch (e) {
    console.warn("Invalid GOOGLE_LOCATION JSON");
  }

  let longName = "";

  const subloComponent = place.address_components.find(component =>
    component.types.includes("sublocality_level_1")
  );

  if (subloComponent) {
    longName = subloComponent.long_name;
  } else if (locationObj.address_components && locationObj.address_components.length > 0) {
    longName = locationObj.address_components[0].long_name;
    console.log("Fallback longName used from GOOGLE_LOCATION");
  } else {
    //longName = postalCode; // fallback to postalCode if all else fails
    console.warn("No sublocality found. Using postalCode as fallback.");
  }

  const sideBox = document.querySelector(".side-container .side-box");

  $('#pac-input').val("");

  const form = new FormData();
  form.append("lat", latitude);
  form.append("lng", longitude);

  $.ajax({
    url: starquik + "getlocationapi",
    method: "POST",
    timeout: 0,
    processData: false,
    contentType: false,
    data: form,
    success: function (response) {
      try {
        const res = typeof response === "string" ? JSON.parse(response) : response;

        if (res.status === true) {
          $(".service-not-applicable").html('');
          $('.select-location-label').html(`
            ${longName} <img class="small-hide medium-hide" src="https://cdn.shopify.com/s/files/1/0678/1947/0941/files/map.png?v=1740646952" loading="lazy" alt="Map" width="10px" height="13px">
          `);
          
          console.log(`${longName} <img class="small-hide medium-hide" src="https://cdn.shopify.com/s/files/1/0678/1947/0941/files/map.png?v=1740646952" loading="lazy" alt="Map" width="10px" height="13px">`);
          localStorage.setItem("longName", `${longName}`);
          
          const { store_id, location_id, nearest_time, date } = res;
          const fullStoreId = `SC_${store_id.toLowerCase()}`;
          const oldStoreId = localStorage.getItem("store_id");
          localStorage.setItem("store_id", fullStoreId);
          localStorage.setItem("location_id", location_id);

          const formattedDate = formatDateToReadable(date);
          const message = `Next available delivery slot: ${formattedDate} ${nearest_time}`;
          localStorage.setItem("delivery_slot_message", message);
          const deliverySlotElement = document.querySelector(".order-del-subpara");
          if (deliverySlotElement) {
            deliverySlotElement.innerText = message;
          }
         // window.location.reload();
          
          //$('.store-location-popup-overlay').css('display','flex');
          // Check if store_id has changed
        // Check store_id change and cart count
        // if (oldStoreId && oldStoreId !== fullStoreId) {
        //   // Check cart count
        //   $.getJSON('/cart.js', function(cart) {
        //     if (cart.items.length > 0) {
        //       $('.store-location-popup-overlay').css('display', 'flex');
        //     } else {
        //       window.location.reload();
        //     }
        //   });
        // } else {
        //   window.location.reload();
        // }
          // Always check cart contents
        $.getJSON('/cart.js', function(cart) {
          const cartCount = cart.items.length;

          // Condition 1: First-time location select (no old store) AND cart has items
          const isFirstTime = !oldStoreId;
          // Condition 2: Changing store_id AND cart has items
          const isStoreChanged = oldStoreId && oldStoreId !== fullStoreId;

          if ((isFirstTime && cartCount > 0) || (isStoreChanged && cartCount > 0)) {
            $('.store-location-popup-overlay').css('display', 'flex');
          } else {
            window.location.href = '/';
          }
        });
          sessionStorage.setItem("wizzy_store", "");
          console.log("wizzy_store removed from sessionStorage");
          if (sideBox) {
            setTimeout(() => {
              sideBox.classList.remove("open-side");
            }, 200);
          }

          console.log("store_id and location_id saved to localStorage");
        } else {
          console.warn("No stores found:", res.message || "Unknown error");
          clearLocationDataAndShowError();
        }
      } catch (e) {
        console.error("Failed to parse response:", e);
        clearLocationDataAndShowError();
      }
    },
    error: function () {
      clearLocationDataAndShowError();
    }
  });
} else {
  clearLocationDataAndShowError();
}

// Utility function to reset localStorage and show fallback UI
function clearLocationDataAndShowError() {
  localStorage.removeItem("store_id");
  localStorage.removeItem("location_id");
  localStorage.removeItem("delivery_slot_message");
  localStorage.removeItem("GOOGLE_LOCATION");

  $(".service-not-applicable").html(`
    <div class="service-not-applicable-box">
      <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/Location.png?v=1741862281" height="100px" width="100px" alt="location-unavailable"/>
      <p class="service-not-applicable-para">
        Sorry! At the moment, we’re not delivering here. If we expand our service in the future, we’ll notify you. Watch this space for more & stay tuned!
      </p>
    </div>
  `);
}

            }
        }
    );
};
function initMap() {
    //alert("initMap");
    const card = document.getElementById("pac-card");
    const input = document.getElementById("pac-input");
    const inputProfile = document.getElementById("pac-input-profile");
    if (!googleapisToken) {
        googleapisToken = new google.maps.places.AutocompleteSessionToken();
      }
   
    const options = {
        strictBounds: false,
        types: ["establishment"],
        sessionToken:googleapisToken,
     
    };
   // const sessionToken = googleapisToken;

    const autocomplete = new google.maps.places.Autocomplete();
    const autocompleteService = new google.maps.places.AutocompleteService();
    const infowindow = new google.maps.InfoWindow();
    const infowindowContent = document.getElementById("infowindow-content");
    const infowindowContentProfile = document.getElementById(
        "infowindow-content-profile"
    );

    input?.addEventListener("input", () => {
        
        const query = input.value;
        if (query.trim() == "") {
            $(".location-suggestions").empty();
        }
        
        if (!googleapisToken) {
            googleapisToken = new google.maps.places.AutocompleteSessionToken();
          }

        autocompleteService.getPlacePredictions(
            {
                input: query,
                componentRestrictions: { country: "IN" },
                sessionToken:googleapisToken,
            },
            
            (predictions, status) => {
                
                if (
                    status === google.maps.places.PlacesServiceStatus.OK &&
                    predictions
                ) {
                    $(".location-suggestions").empty();
                    predictions = predictions.filter(
                        (suggestion) =>
                            suggestion.types.indexOf("locality") <= -1
                    );
                    for (let i = 0; i < predictions.length; i++) {
                
                        const currLoc = predictions[i];
                        $(".location-suggestions").append(`
                        <div class="location-suggestions-item" onclick="newhandleLocationSearchSelection('${currLoc?.place_id}','Header')">
                          <div class="location-suggestions-item-icon">
                            <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/map.png?v=1741861962" alt="Map" width="10px" height="13px" style="margin-top:3px"/>
                          </div>
                          <div class="location-suggestions-item-text">
                            <span style="">${currLoc?.structured_formatting?.main_text}</span>
                            <br/>
                            <span style="font-size:12px; color:#808590">${currLoc?.description}</span>
                          </div>
                        </div>
                        `);
                    }
                }
            }
        );
    });
    inputProfile?.addEventListener("input", () => {
        
        const query = inputProfile?.value;
        if (query.trim() == "") {
            $(".location-suggestions-profile").empty();
        }
        if (!googleapisToken) {
            googleapisToken = new google.maps.places.AutocompleteSessionToken();
          }

        autocompleteService.getPlacePredictions(
            {
                input: query,
                types: ["establishment"],
                sessionToken:googleapisToken,
            },
            (predictions, status) => {
                if (
                    status === google.maps.places.PlacesServiceStatus.OK &&
                    predictions
                ) {
                    
                  
                    $(".location-suggestions-profile").empty();
                    for (let i = 0; i < predictions.length; i++) {
                        const currLoc = predictions[i];
                        $(".location-suggestions-profile").append(`
                        <div class="location-suggestions-item" onclick="newhandleLocationSearchSelection('${currLoc?.place_id}','Address')">
                          <div class="location-suggestions-item-icon">
                            <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/map.png?v=1741861962" alt="Map" width="10px" height="13px" style="margin-top:3px"/>
                          </div>
                          <div class="location-suggestions-item-text">
                            <span style="">${currLoc?.structured_formatting?.main_text}</span>
                            <br/>
                            <span style="font-size:12px; color:#808590">${currLoc?.description}</span>
                          </div>
                        </div>
                        `);
                    }
                }
            }
        );
    });

    infowindow.setContent(infowindowContent);
    infowindow.setContent(infowindowContentProfile);

    autocomplete.addListener("place_changed", () => {

        infowindow.close();
        const place = autocomplete.getPlace();
        localStorage.removeItem("LOCATION");
        localStorage.removeItem("GOOGLE_LOCATION");
        localStorage.removeItem("PickupLocation");
        localStorage.setItem("GOOGLE_LOCATION", JSON.stringify(place));
        const latitude = place?.geometry?.location?.lat();
        const longitude = place?.geometry?.location?.lng();
        if (latitude && longitude) {
            // const briefLocation = place.name;
            // const fullLocation = place.formatted_address;
            // fetch(
            //     baseUrl +
            //         "/v2/home/location?latitude=" +
            //         latitude +
            //         "&longitude=" +
            //         longitude,
            //     {
            //         headers: {
            //             temptoken,
            //             storeid,
            //             deviceid,
            //             device,
            //         },
            //     }
            // )
            //     .then((res) => res.json())
            //     .then((data) => {
            //         if (data.status === "non serviceable") {
                        
            //             //localStorage.removeItem("GOOGLE_LOCATION");
            //             $(".service-not-applicable").empty();
            //             $(".location-top-section-services-available").empty();
            //             $(".service-not-applicable")
            //                 .append(`<div class="service-not-applicable-box">
            //                 <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/Location.png?v=1741862281" height="100px" width="100px" alt="location-unavailable"/>
                            
            //                 <p class="service-not-applicable-para">${data.areatext}</p>
            //                 </div>`);
            //             $(".location-top-section-services-available")
            //                 .append(`<div class="service-not-applicable-box">
            //                 <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/Location.png?v=1741862281" height="100px" width="100px" alt="location-unavailable"/>
                            
            //                 <p class="service-not-applicable-para">${data.areatext}</p>
            //                 </div>`);
            //             $(".location-bottom-section").css("display", "none");
            //         } else if (data.status === "pickup") {
            //             localStorage.setItem(
            //                 "PickupLocation",
            //                 JSON.stringify(data)
            //             );
            //             const location = data.pickup_stores[0];
            //             const isServicable =
            //             data.status === "non serviceable" ? false : true;
            //         localStorage.setItem(
            //             "LOCATION",
            //             JSON.stringify(location)
            //         );
            //         $.ajax({
            //             type: "GET",
            //             url: `/set_data/${location.store_id}`,
            //             dataType: "json",
            //             success: function (result) {},
            //         });
            //         localStorage.setItem(
            //             "isServicable",
            //             JSON.stringify(isServicable)
            //         );
            //         var modal = document.querySelector(".location-modal");
            //         modal.classList.toggle("location-show-modal");
            //         $("body").css("overflow", "auto");
                    
            //         fireLocationEvent(data.status ,JSON.parse(localStorage.getItem("GOOGLE_LOCATION"))); 
            //         fireLocationSelectedEvent('locationselected' ,JSON.parse(localStorage.getItem("GOOGLE_LOCATION")));
            //         window['dataLayer'].push({
            //             'storeID': location.store_id
            //           });                        
            //         const locality = place.address_components.filter(
            //             (address) =>
            //             address.types.includes("sublocality_level_1") == false ?  address.types.includes("locality"):address.types.includes("sublocality_level_1")
            //         )[0].short_name;
            //         $(".select-location-label").empty();
            //         $(".select-location-label").append(`${truncateString(
            //             locality
            //         )} <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/map.png?v=1741861962" alt="Map" width="10px"
            //         height="13px"/> `);
            //         setTimeout(() => {
            //             window.location.reload();
            //         }, 1000);
            //         } 
            //         else if (data.status === "serviceable") {
            //             const location = data.data[0];
            //             const isServicable =
            //                 data.status === "non serviceable" ? false : true;
            //             localStorage.setItem(
            //                 "LOCATION",
            //                 JSON.stringify(location)
            //             );
            //             $.ajax({
            //                 type: "GET",
            //                 url: `/set_data/${location.store_id}`,
            //                 dataType: "json",
            //                 success: function (result) {},
            //             });
            //             localStorage.setItem(
            //                 "isServicable",
            //                 JSON.stringify(isServicable)
            //             );
            //             var modal = document.querySelector(".location-modal");
            //             modal.classList.toggle("location-show-modal");
            //             $("body").css("overflow", "auto");
                        
            //             fireLocationEvent(data.status ,JSON.parse(localStorage.getItem("GOOGLE_LOCATION"))); 
            //             fireLocationSelectedEvent('locationselected' ,JSON.parse(localStorage.getItem("GOOGLE_LOCATION")));
            //             window['dataLayer'].push({
            //                 'storeID': location.store_id
            //               });                        
            //             const locality = place.address_components.filter(
            //                 (address) =>
            //                 address.types.includes("sublocality_level_1") == false ?  address.types.includes("locality"):address.types.includes("sublocality_level_1")
            //             )[0].short_name;
            //             $(".select-location-label").empty();
            //             $(".select-location-label").append(`${truncateString(
            //                 locality
            //             )} <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/map.png?v=1741861962" alt="Map" width="10px"
            //             height="13px"/> `);
            //             setTimeout(() => {
            //                 window.location.reload();
            //             }, 1000);
            //         } else {
            //             Swal.fire({
            //                 html: `<div class="swal_container_message">Something went wrong, please try again.</div>`,
            //                 showCancelButton: true,
            //                 showConfirmButton: false,
            //                 icon: "error",
            //                 customClass: {
            //                     content: "swal_textcolorprofile",
            //                     cancelButton: "swal_button_textcolorprofile",
            //                 },
            //                 cancelButtonText: "Close",
            //             });
            //         }
            //     });
        }

        if (!place.geometry || !place.geometry.location) {
            $(".service-not-applicable").empty();
            $(".location-bottom-section").empty();
            $(".service-not-applicable").append(
                `<span class="location-bottom-section">No details available for input: '${place.name}</span>`
            );
            $(".location-top-section-continue").empty();
            $(".location-top-section-services-available").empty();
            $(".location-top-section-services-available").append(
                `<span class="location-bottom-section">No details available for input: '${place.name}</span>`
            );
            return;
        }

        infowindowContent.children["place-name"].textContent = place.name;
        infowindowContent.children["place-address"].textContent =
            place.formatted_address;
        infowindowContentProfile.children["place-name"].textContent =
            place.name;
        infowindowContentProfile.children["place-address"].textContent =
            place.formatted_address;
    });
}

const userLocation = localStorage.getItem("GOOGLE_LOCATION");
const storeLocation = localStorage.getItem("LOCATION");

const parsedUserLocation = JSON.parse(userLocation);

if (parsedUserLocation?.geometry) {
    $(".select-location-label").empty();
    // $(".select-location-label").append(
    //     `${truncateString(
    //         parsedUserLocation?.address_components?.filter((address) =>
    //             address.types.includes("sublocality_level_1") == false ?  address.types.includes("locality"):address.types.includes("sublocality_level_1")
    //         )?.[0]?.short_name
    //     )} <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/map.png?v=1741861962" alt="Map" width="10px" height="13px"/> `
    // );
} else {
    //window.initMap = initMap;
}

// function OldLocation(store_id) {
//     $.ajax({
//         type: "GET",
//         url: `/set_data/${store_id}`,
//         dataType: "json",
//         success: function (result) {},
//     });

//     localStorage.setItem("GOOGLE_LOCATION", userLocation);
//     localStorage.setItem("LOCATION", storeLocation);

//     setTimeout(() => {
//         window.location.reload();
//     }, 1000);
// }

$(document).ready(function () {
  const savedMessage = localStorage.getItem("delivery_slot_message");
  const longName = localStorage.getItem("longName");
  if (savedMessage) {
    const deliverySlotElement = document.querySelector(".order-del-subpara");
    if (deliverySlotElement) {
      deliverySlotElement.innerText = savedMessage;
    }
  }
  if (longName) {
    const longNameState = document.querySelector(".select-location-label");
    if (longNameState) {
      longNameState.innerText = longName;
    }
  }
});
